module.exports = __webpack_public_path__ + "static/media/NAC-USA-Expo-Website.jpg";